export default "__VITE_ASSET__BqtdfGJv__"